<template>
<ContractorsAddresses v-if="access"/> 
<NoAccess v-else/>
</template>

<script>
import ContractorsAddresses from '../components/ContractorsAddresses'
import NoAccess from '../components/NoAccess'

import {
    HTTP
} from '../http-common'

export default {
    components: {
        ContractorsAddresses,
        NoAccess
    },
    data() {
        return {
            access: true
        }
    },
    created() {
        HTTP.get('/auth/user-info')
            .then(response => {
                this.$store.commit('setUserInfo', response.data.data)
                if (!response.data.data || response.data.data.id == 0 || !response.data.data.id) {
                    this.$router.push({
                        name: 'login'
                    })
                }
                if (response.data && response.data.data) {
                    this.access = response.data.data.type.indexOf('1') >= 0 || response.data.data.type.indexOf(1) >= 0 || response.data.data.type.indexOf('3') >= 0 ?  true : false
                } else {
                    this.access = false
                }
            })
    }
}
</script>
